var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-layout"},[_c('div',{staticClass:"page-title"},[_vm._v("개인정보 제3자 제공동의")]),_c('div',{staticClass:"pageAgreementFullText",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }